export const SIDEBAR_COLLAPSE_BREAKPOINT = 768
export const EXPANDED_SIDEBAR_WIDTH = 178

export const EXPANDED_SIDEBAR_WIDTH_CLASS = "w-[178px]"
